<template>
  <v-row class="mb-4" dense>
    <v-col cols="12" sm="6" md="3">
      <v-menu
        v-model="menuFrom"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            v-model="local.date_from"
            label="С даты"
            prepend-inner-icon="mdi-calendar"
            readonly
            dense
            outlined
            hide-details
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="local.date_from"
          locale="ru"
          @input="menuFrom = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-menu
        v-model="menuTo"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            v-model="local.date_to"
            label="По дату"
            prepend-inner-icon="mdi-calendar"
            readonly
            dense
            outlined
            hide-details
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="local.date_to"
          locale="ru"
          @input="menuTo = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col
      v-if="showAttribution"
      cols="12"
      sm="6"
      md="3"
    >
      <v-select
        v-model="local.attribution"
        :items="attributionItems"
        label="Атрибуция"
        dense
        outlined
        hide-details
        hint="Кому засчитать клиента в источниках"
        persistent-hint
      ></v-select>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-autocomplete
        v-model="local.source"
        :items="sourceItems"
        label="Источник"
        dense
        outlined
        hide-details
        clearable
        :loading="optionsLoading"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-autocomplete
        v-model="local.campaign"
        :items="campaignItems"
        label="Кампания"
        dense
        outlined
        hide-details
        clearable
        :loading="optionsLoading"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-select
        v-model="local.company_id"
        :items="branchItems"
        label="Филиал"
        dense
        outlined
        hide-details
        clearable
      ></v-select>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="d-flex align-center">
      <v-btn color="primary" class="mr-2" @click="apply">
        Применить
      </v-btn>
      <v-btn text @click="reset">
        Сбросить
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Api from '@/api/api'

const emptyFilters = () => ({
  date_from: '',
  date_to: '',
  attribution: 'lead',
  source: '',
  campaign: '',
  company_id: null,
})

export default {
  name: 'AnalyticsFilters',
  props: {
    value: {
      type: Object,
      default: () => emptyFilters(),
    },
    showAttribution: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      local: { ...emptyFilters(), ...this.value },
      menuFrom: false,
      menuTo: false,
      optionsLoading: false,
      sourceItems: [],
      campaignItems: [],
      attributionItems: [
        { text: 'Lead Touch', value: 'lead' },
        { text: 'First Touch', value: 'first' },
      ],
      branchItems: [
        { text: 'Space Химки', value: '230691' },
        { text: 'Space ВДНХ', value: '992575' },
        { text: 'Залы Khimki BC', value: '232685' },
      ],
    }
  },
  watch: {
    value: {
      deep: true,
      handler(v) {
        this.local = { ...emptyFilters(), ...v }
      },
    },
  },
  mounted() {
    this.loadOptions()
  },
  methods: {
    async loadOptions() {
      this.optionsLoading = true
      try {
        const data = await Api.getAnalyticsOptions()
        this.sourceItems = data.sources || []
        this.campaignItems = data.campaigns || []
      } catch (e) {
        this.sourceItems = []
        this.campaignItems = []
      } finally {
        this.optionsLoading = false
      }
    },
    apply() {
      this.$emit('input', { ...this.local })
      this.$emit('apply', { ...this.local })
    },
    reset() {
      this.local = emptyFilters()
      this.apply()
    },
  },
}
</script>
